import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "handlebar-selection__results" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }

import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { useHandlebarStore } from '@/store/handlebarStore'
import { useBikeStore } from '@/store/bikeStore'
import {
  ListItemState,
  BfLoader,
  BfList,
  BfListItem,
  BfFlex,
  BfInput,
} from '@finetic/bikefitting-ui'
import { useDebounceFn } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import SelectionDetails from '@/components/setup/SelectionDetails.vue'
import SelectionDetailsItem from '@/components/setup/SelectionDetailsItem.vue'
import { BikeHoodsType } from '@/types/bike'
import handlebarService from '@/service/handlebarService'


export default /*@__PURE__*/_defineComponent({
  __name: 'HandlebarSelection',
  emits: ['select'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const userStore = useUserStore()
const handlebarStore = useHandlebarStore()
const bikeStore = useBikeStore()
const { sessionId } = storeToRefs(userStore)
const { handlebarData, filters } = storeToRefs(handlebarStore)
const { bikeHoodsType } = storeToRefs(bikeStore)
const loading = ref(false)
const selected = ref()

const handlebarFilter = computed(() => {
  switch (bikeHoodsType.value) {
    case BikeHoodsType.DROPBAR:
      return 1
    case BikeHoodsType.FLATBAR:
      return 200
    case BikeHoodsType.TRIBAR:
      return 300
    default:
      return 1
  }
})

const handlebarDataFiltered = computed(() => {
  return handlebarData.value.filter(
    (obj) => obj.HANDLEBAR_FILTER === handlebarFilter.value,
  )
})

const widthIcon = () => {
  return handlebarService.getWidthIcon(bikeHoodsType.value)
}

const sweepIcon = () => {
  return handlebarService.getSweepIcon(bikeHoodsType.value)
}

const emit = __emit

handlebarStore.reset()

const select = (handlebar: any) => {
  selected.value = handlebar
  emit('select', handlebar)
}

const search = () => {
  loading.value = true

  handlebarStore.reset()
  handlebarStore.retrieveHandlebars(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}

const updateSearch = useDebounceFn(() => {
  search()
}, 300)

search()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BfFlex), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BfInput), {
          modelValue: _unref(filters).FreeTextSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).FreeTextSearch) = $event)),
          name: _unref(t)('common.search.filterBrandOrModel'),
          placeholder: _unref(t)('common.search.filterBrandOrModel'),
          style: {"flex":"1"},
          onKeyup: _unref(updateSearch)
        }, null, 8, ["modelValue", "name", "placeholder", "onKeyup"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createBlock(_unref(BfLoader), { key: 0 }))
        : _createCommentVNode("", true),
      (handlebarDataFiltered.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(BfList), { key: 1 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(handlebarDataFiltered.value, (handlebar, i) => {
                return (_openBlock(), _createBlock(_unref(BfListItem), {
                  key: i,
                  text: `${handlebar.HANDLEBAR_BRAND} ${handlebar.HANDLEBAR_MODEL} (${handlebar.HANDLEBAR_WIDTH} ${_unref(t)('common.unit.mm')})`,
                  state: 
          handlebar === selected.value ? _unref(ListItemState).Active : _unref(ListItemState).Enabled
        ,
                  onClick: ($event: any) => (select(handlebar))
                }, null, 8, ["text", "state", "onClick"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)('common.search.noResults')), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    (selected.value)
      ? (_openBlock(), _createBlock(SelectionDetails, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(SelectionDetailsItem, {
              label: _unref(t)('setup.handlebar.width'),
              value: `${selected.value.HANDLEBAR_WIDTH} ${_unref(t)('common.unit.mm')}`,
              icon: widthIcon()
            }, null, 8, ["label", "value", "icon"]),
            (_unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR)
              ? (_openBlock(), _createBlock(SelectionDetailsItem, {
                  key: 0,
                  label: _unref(t)('setup.handlebar.reach'),
                  value: `${selected.value.HANDLEBAR_REACH} ${_unref(t)('common.unit.mm')}`,
                  icon: "/icons/filters/handlebar__road--reach.svg"
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (_unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR)
              ? (_openBlock(), _createBlock(SelectionDetailsItem, {
                  key: 1,
                  label: _unref(t)('setup.handlebar.drop'),
                  value: `${selected.value.HANDLEBAR_DROP} ${_unref(t)('common.unit.mm')}`,
                  icon: "/icons/filters/handlebar__road--drop.svg"
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (
        _unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR ||
        _unref(bikeHoodsType) === _unref(BikeHoodsType).FLATBAR
      )
              ? (_openBlock(), _createBlock(SelectionDetailsItem, {
                  key: 2,
                  label: _unref(t)('setup.handlebar.sweep'),
                  value: `${selected.value.BACK_SWEEP_ANGLE} ${_unref(t)('common.unit.degreesSign')}`,
                  icon: sweepIcon()
                }, null, 8, ["label", "value", "icon"]))
              : _createCommentVNode("", true),
            (_unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR)
              ? (_openBlock(), _createBlock(SelectionDetailsItem, {
                  key: 3,
                  label: _unref(t)('setup.handlebar.flare'),
                  value: `${selected.value.FLARE_ANGLE} ${_unref(t)('common.unit.degreesSign')}`,
                  icon: "/icons/filters/handlebar__road--flare.svg"
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})